import axiosInstance from "@/utils/AxiosInstance";
import {RequestClientPage} from "@/services/clients/entities/RequestClientPage";
import {RequestUpdateClientInfo} from "@/services/clients/entities/RequestUpdateClientInfo";
import {RequestChangeClientStatus} from "@/services/clients/entities/RequestChangeClientStatus";
import {NewClient} from "@/services/clients/entities/NewClient";

const BASE_API = '/clients';

const getClientPage = async (body: RequestClientPage): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/page`, body);
}

const getClientDetails = async (clientId: string): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/${clientId}`);
}

const assignClientToOffice = async (body: any): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/assign`, body);
}

const changeClientType = async (body: any): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/change-type`, body);
}

const updateClientInfo = async (body: RequestUpdateClientInfo): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/`, body);
}

const changeClientStatus = async (body: RequestChangeClientStatus): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/change-status`, body);
}

const createClient = async (body: NewClient): Promise<any> => {
    return await axiosInstance.post(`${BASE_API}/`, body);
}

const getClientConsultationInfo = async (clientId: string): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/consultation/${clientId}`);
}

const updateClientNotes = async (body: any): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/notes`, body);
}

const changeClientActivityLevel = async (clientId: string): Promise<any> => {
    return await axiosInstance.patch(`${BASE_API}/${clientId}/activity-level`);
}

const updateClientCatalogs = async (body: any): Promise<any> => {
    return await axiosInstance.patch(`${BASE_API}/catalogs`, body);
}

export default {
    getClientPage,
    getClientDetails,
    assignClientToOffice,
    changeClientType,
    updateClientInfo,
    changeClientStatus,
    createClient,
    getClientConsultationInfo,
    updateClientNotes,
    changeClientActivityLevel,
    updateClientCatalogs
}